module.exports = __webpack_public_path__ + "img/hero-igreja.fceb1a24.svg";